import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDrawerEnvelope = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "drawer-envelope" }),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "7.695 12.606 15.4 13.107 19.896 6.83"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.75,18.75l6.642-3.144a1.5,1.5,0,0,0,.714-2L19.9,6.83a1.5,1.5,0,0,0-2-.714l-9.49,4.492a1.5,1.5,0,0,0-.714,2L10.6,18.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M2.25,2.25a3,3,0,0,0,3,3h9a3,3,0,0,0,3-3"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M2.25,18.75V2.25A1.5,1.5,0,0,1,3.75.75h12a1.5,1.5,0,0,1,1.5,1.5V6.423"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 9.75,
			y1: 5.25,
			x2: 9.75,
			y2: 9.973
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21.75,23.25H2.25a1.5,1.5,0,0,1-1.5-1.5v-3h22.5v3A1.5,1.5,0,0,1,21.75,23.25Z"
		})
	]
});
export default SvgDrawerEnvelope;
